"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var gprs_diagnosis_1 = require("../../../shared/model/gprs-diagnosis");
var diagnosis_web_socket_service_1 = require("../../service/diagnosis-web-socket.service");
var attribute_state_1 = require("../../model/attribute-state");
var GprsDiagnosisComponent = /** @class */ (function () {
    function GprsDiagnosisComponent(_diagnosisNotification) {
        this._diagnosisNotification = _diagnosisNotification;
        this.gprs = {};
        this.running = true;
    }
    GprsDiagnosisComponent.prototype.ngOnInit = function () {
        if (this._run) {
            this.observeRestart();
            this.setEmptyEntities();
            this.subscribeGprsSuccess();
            this.subscribeGprsFail();
        }
        else {
            this.displayViewMode();
        }
    };
    Object.defineProperty(GprsDiagnosisComponent.prototype, "run", {
        get: function () {
            return this._run;
        },
        set: function (run) {
            this._run = run;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(GprsDiagnosisComponent.prototype, "gprsDiagnosis", {
        get: function () {
            return this._gprsDiagnosis;
        },
        set: function (gprsDiagnosis) {
            this._gprsDiagnosis = gprsDiagnosis;
        },
        enumerable: true,
        configurable: true
    });
    GprsDiagnosisComponent.prototype.observeRestart = function () {
        var _this = this;
        this._diagnosisNotification.restart$
            .subscribe(function () {
            _this.setEmptyEntities();
            _this.running = true;
        });
    };
    GprsDiagnosisComponent.prototype.setEmptyEntities = function () {
        this.loadingText = 'Carregando...';
        this.gprsDiagnosis = new gprs_diagnosis_1.GprsDiagnosis();
        this.gprs = new gprs_diagnosis_1.GprsDiagnosis();
    };
    GprsDiagnosisComponent.prototype.subscribeGprsSuccess = function () {
        var _this = this;
        this._diagnosisNotification.success$
            .filter(function (data) { return data instanceof gprs_diagnosis_1.GprsDiagnosis; })
            .subscribe(function (gprsDiagnosis) {
            _this.setAttributeState(gprsDiagnosis, attribute_state_1.AttributeState.SUCCESS);
            _this.updateDiagnosisDisplay(gprsDiagnosis);
        });
    };
    GprsDiagnosisComponent.prototype.subscribeGprsFail = function () {
        var _this = this;
        this._diagnosisNotification.failed$
            .filter(function (data) { return data instanceof gprs_diagnosis_1.GprsDiagnosis; })
            .subscribe(function (gprsDiagnosis) {
            _this.setAttributeState(gprsDiagnosis, attribute_state_1.AttributeState.FAIL);
            _this.updateDiagnosisDisplay(gprsDiagnosis);
        });
    };
    GprsDiagnosisComponent.prototype.updateDiagnosisDisplay = function (gprsDiagnosis) {
        this.gprsDiagnosis = gprsDiagnosis;
        this.running = this._gprsDiagnosis.isRunning;
        if (!this.running) {
            this.loadingText = 'Indisponível';
        }
    };
    GprsDiagnosisComponent.prototype.setAttributeState = function (gprsResponse, state) {
        var _this = this;
        Object.keys(gprsResponse).forEach(function (key) {
            if (!(key in _this._gprsDiagnosis)) {
                _this.gprs[key] = state;
            }
        });
    };
    GprsDiagnosisComponent.prototype.displayViewMode = function () {
        this.setupGprsStatus();
        this._gprsDiagnosis = this._gprsDiagnosis.gprsData;
    };
    GprsDiagnosisComponent.prototype.setupGprsStatus = function () {
        var _this = this;
        var gprsStatus = { 'rssi': this._gprsDiagnosis.rssi, 'data': this._gprsDiagnosis.data,
            'available': this._gprsDiagnosis.available };
        Object.keys(gprsStatus).forEach(function (key) {
            _this.setStateOnAtrribute(key, gprsStatus[key]);
        });
    };
    GprsDiagnosisComponent.prototype.setStateOnAtrribute = function (key, value) {
        if (value) {
            this.gprs[key] = attribute_state_1.AttributeState.SUCCESS;
        }
        else {
            this.gprs[key] = attribute_state_1.AttributeState.FAIL;
        }
    };
    GprsDiagnosisComponent.ctorParameters = function () { return [{ type: diagnosis_web_socket_service_1.DiagnosisWebSocketService }]; };
    return GprsDiagnosisComponent;
}());
exports.GprsDiagnosisComponent = GprsDiagnosisComponent;
//# sourceMappingURL=gprs-diagnosis.component.js.map


// WEBPACK FOOTER //
// gprs-diagnosis.component.js